module.exports = __webpack_public_path__ + "assets/c509fd016593cd8547a0fc00fba18668.png";